export const SET_ITEMS = 'SET_ITEMS'
export const SET_COLLECTIONS = 'SET_COLLECTIONS'
export const SET_ALL_TEXTS = 'SET_ALL_TEXTS'
export const SET_SINGLE = 'SET_SINGLE'
export const SET_INDEX = 'SET_INDEX'
export const SET_COLLECTION = 'SET_COLLECTION'
export const SET_SEARCH = 'SET_SEARCH'
export const SET_TERM = 'SET_TERM'
export const SET_CONTEXT = 'SET_CONTEXT'
export const SET_N = 'SET_N'
export const SET_BUSY = 'SET_BUSY'
export const RESET_SINGLE_ITEM = 'RESET_SINGLE_ITEM'
export const RESET_COLLECTION = 'RESET_COLLECTION'
export const RESET_SEARCH = 'RESET_SEARCH'
export const HIDE_TEXT = 'HIDE_TEXT'
export const SHOW_TEXT = 'SHOW_TEXT'
export const SHOW_SHARE = 'SHOW_SHARE'
export const HIDE_SHARE = 'HIDE_SHARE'
export const SET_COLLECTION_ENTRY = 'SET_COLLECTION_ENTRY'
export const SET_FILTER = 'SET_FILTER'



// WEBPACK FOOTER //
// ./src/store/mutationTypes.js